import { request } from '@lib/request';
import { requestInterceptors, responseInterceptorOnFulfilled, responseInterceptorOnRejected } from './interceptors';

request.interceptors.request.use(requestInterceptors);

request.interceptors.response.use(responseInterceptorOnFulfilled, responseInterceptorOnRejected);
